import Autoplay from "embla-carousel-autoplay"

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel.tsx"
import { Label } from "@/components/ui/label.tsx"
import { Skeleton } from "@/components/ui/skeleton.tsx"
import type { KPI } from "@/types/kpiTypes.ts"

import KPIChart from "./KPIChart.tsx"

import type { KPIChartCarouselConfig } from "../types/kpiChartCarouselTypes.ts"

export default function KPIChartCarousel({
  config,
  data,
  isLoading,
  isError,
}: {
  config: KPIChartCarouselConfig
  data: KPI[] | undefined
  isLoading: boolean
  isError: boolean
}) {
  if (isError)
    return (
      <div className="rounded-md shadow-sm p-4 border h-full">
        <h2 className="text-lg font-semibold mb-1">{config.title}</h2>
        <div className="w-full h-full text-status-bad font-semibold">Network Error</div>
      </div>
    )

  return (
    <div className="rounded-md shadow-sm p-4 border max-w-full overflow-x-hidden min-h-full flex flex-col bg-card">
      <h2 className="text-lg font-semibold mb-1">{config.title}</h2>
      {isLoading ? (
        <Skeleton className="w-full grow" />
      ) : (
        <Carousel
          opts={{
            loop: true,
          }}
          plugins={[
            Autoplay({
              delay: 10000,
              stopOnMouseEnter: true,
              stopOnInteraction: false,
            }),
          ]}
        >
          <CarouselContent>
            {data?.map((kpi, i) => (
              <CarouselItem key={i} className="h-[300px] md:h-[400px]">
                <Label className="text-muted-foreground text-[12pt]">{config.labels[i]}</Label>
                <KPIChart
                  kpi={kpi}
                  minHeight={270}
                  includeTarget={config.includeTargets}
                  variant={config.variant}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="-left-0 -translate-y-7 top-full" />
          <CarouselNext className="-right-0 -translate-y-7 top-full" />
        </Carousel>
      )}
    </div>
  )
}
